/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { schema } from 'normalizr';

import {
  ENTITY_TYPES,
  getYesNoTranslationForLang
} from '../../util/actionUtil';

export const entitySchema = new schema.Entity(
  'entities',
  {},
  {
    idAttribute: 'entity',
    processStrategy: entity => {
      const updated = entity?.entity?.startsWith('sys-')
        ? { ...entity, type: 'system' }
        : { ...entity };
      if (updated.values) {
        //add 'originalValue' so that modals will have reference to the original value when applying changes
        updated.values.forEach(value => ({
          ...value,
          originalValue: value.value
        }));
      }
      if (updated.entity === ENTITY_TYPES.confirmation.id) {
        //yes/no system entity is a special case - it is treated like options entity in the ui
        const { language = 'en' } = updated;
        updated.values = getYesNoTranslationForLang(language);
      }
      return updated;
    }
  }
);
export const entitiesSchema = new schema.Array(entitySchema);
